import React, { Component } from 'react';

export default class Sider extends Component {

    state = {
    };

    constructor(props, context) {
        super(props, context);
    }

    render() {

        return (
            <div className={"plot-designer-sider layout-v " + (this.props.className || "")} style={this.props.style}>
                {this.props.title ? <span className='title primary-text' title={this.props.title}>{this.props.title}</span> : null}
                <div className="layout-v h0 fill" style={{ position: 'relative' }}>
                    {this.props.children}
                </div>
            </div>
        );
    }
}
